import React from "react";

export default function ConfirmationModal({
    show,
    title = "Confirm Action",
    message,
    children,
    onConfirm,
    onCancel,
    confirmText = "Confirm",
    cancelText = "Cancel",
    confirmDisabled = false,
    contentClassName = ""
}) {
    if (!show) return null;

    return (
        <div className="modalOverlay">
            <div className={`modalContent ${contentClassName}`}>
                <h5>{title}</h5>

                {children ? children : (message && <p>{message}</p>)}

                <div className="modalActions" style={{ display: "flex", justifyContent: "end", gap: "10px" }}>
                    <button className="btn btn-cancel" onClick={onCancel}>
                        {cancelText}
                    </button>
                    <button
                        className="btn btn-confirm"
                        onClick={onConfirm}
                        disabled={confirmDisabled}
                        style={{
                            opacity: confirmDisabled ? 0.6 : 1,
                            cursor: confirmDisabled ? "not-allowed" : "pointer"
                        }}
                    >
                        {confirmText}
                    </button>
                </div>
            </div>
        </div>
    );
}
